import { Map, List, fromJS } from 'immutable';

const generateSteps = (steps = []) => {
  let stepList = List();
  steps.forEach((step, idx) => {
    stepList = stepList.push(Map({ position: idx, code: step.code, type: step.type }));
  });
  return stepList;
};

const generateAlterSteps = (alterSteps = {}) => fromJS(alterSteps || {});

const stepChanger =
  (increment = 1) =>
  (payload = null) => {
    return (dispatch, getState) => {
      const step = getState().getIn(['customer', 'step']);
      const stepPosition = step.getIn(['current_step', 'position']);
      const newStepPosition = !payload ? stepPosition + increment : payload;

      let newStep = step.get('list').find((step) => {
        return step.get('position') === newStepPosition || step.get('code') === newStepPosition;
      });
      newStep = newStep || getState().getIn(['customer', 'step', 'current_step']);
      //per incompatiblitat de redux-first i immutables es necessari realizar la conversió, c'est la vie.. :'(
      return newStep.toJS();
    };
  };

const alterStepChanger = (payload = null) => {
  return (dispatch, getState) => {
    const step = getState().getIn(['customer', 'step']);
    const newStepPosition = payload;

    let newStep = step.getIn(['alter_list', newStepPosition]);

    newStep = newStep || getState().getIn(['customer', 'step', 'current_step']);
    return { ...newStep.toJS(), isAlter: true };
  };
};

export default {
  CHANGE: stepChanger(),
  CHANGE_ALTER: alterStepChanger,
  NEXT: stepChanger(),
  PREV: stepChanger(-1),
  UPDATE_ALTER_STEP: (newAlterStep) => {
    return (dispatch, getState) => {
      let alterStepList = getState().getIn(['customer', 'step', 'alter_list'], List());

      const referencedAlterStep = alterStepList.find((step) => {
        return step.get('code') === newAlterStep.get('code');
      });

      if (referencedAlterStep) {
        alterStepList = alterStepList.map((step) => {
          if (step.get('code') === newAlterStep.get('code')) {
            return step.merge(newAlterStep);
          }
          return step;
        });
      }

      return alterStepList;
    };
  },
  INITIALIZE: (startValues) => {
    return (dispatch, getState) => {
      const stepList = generateSteps(startValues.steps);
      const alterStepList = generateAlterSteps(startValues.alter_steps);
      let startStepCurrent = startValues.current_step;
      let currentStepCode = false;

      currentStepCode = stepList.find((step) => {
        return step.get('code') === startStepCurrent;
      });

      if (!currentStepCode) {
        currentStepCode = alterStepList.find((step) => {
          return step.get('code') === startStepCurrent;
        });
      }

      if (!currentStepCode) {
        const defaultState =
          (window.frontLoader && window.frontLoader['cms-avail']?.defaultState) || window.defaultState;
        currentStepCode = stepList.find((step) => {
          return step.get('code') === defaultState.step;
        });
        if (!currentStepCode) {
          currentStepCode = stepList.get(0);
        }
      }

      return Map({
        jump_steps: startValues.jump_steps || List(),
        current_step: currentStepCode,
        required_params: List(startValues.required_params),
        list: stepList,
        alter_list: alterStepList,
        loaded: true
      });
    };
  },
  JUMP_STEPS: {
    SET: (jumpSteps) => {
      return List(jumpSteps);
    },
    REMOVE: (stepCode) => {
      return (dispatch, getState) => {
        const jumpSteps = getState().getIn(['customer', 'step', 'jump_steps'], List());

        if (!jumpSteps) {
          return null;
        }

        const filteredJumpSteps = jumpSteps.filter((code) => code !== stepCode);
        return List(filteredJumpSteps);
      };
    },
    CLEAR: () => {
      return null;
    }
  }
};
